import { Component, ChangeDetectionStrategy, ViewEncapsulation } from "@angular/core";
import { Settings } from "@common/core/config/settings.service";

@Component({
  selector: "newsletter-thankyou",
  templateUrl: "./newsletter-thankyou.component.html",
  styleUrls: ["./newsletter-thankyou.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterThankyouComponent {

  constructor(
    public settings: Settings
  ) {}

}
